// Шаблони повідомлень клієнту (SMS/email) 3 мовами. Майстер обирає шаблон+мову,
// текст підставляється з даних запису й салону та лишається редагованим у модалці.
// Плейсхолдери ctx: salonName, name, date, time, address, code (код дверей), bookUrl.
// B2B: жодних хардкодів конкретного салону — все з активного воркспейсу.

export const MESSAGE_LANGS = ["pl", "uk", "en"];

// Порядок = порядок у випадайці. needsCode → показати поле «код дверей».
export const MESSAGE_TEMPLATES = [
  { key: "reminder", needsCode: false },
  { key: "directions", needsCode: true },
  { key: "reminderDirections", needsCode: true },
  { key: "thanks", needsCode: false },
  { key: "custom", needsCode: false },
];

const hi = { pl: "Cześć", uk: "Вітаємо", en: "Hi" };

const T = {
  reminder: {
    subject: {
      pl: (c) => `Przypomnienie o wizycie — ${c.salonName}`,
      uk: (c) => `Нагадування про запис — ${c.salonName}`,
      en: (c) => `Appointment reminder — ${c.salonName}`,
    },
    body: {
      pl: (c) => `${hi.pl}${c.name ? " " + c.name : ""}! Przypominamy o wizycie w ${c.salonName}: ${c.date} o ${c.time}. Do zobaczenia!`,
      uk: (c) => `${hi.uk}${c.name ? ", " + c.name : ""}! Нагадуємо про ваш запис у ${c.salonName}: ${c.date} о ${c.time}. Чекаємо на вас!`,
      en: (c) => `${hi.en}${c.name ? " " + c.name : ""}! A reminder about your appointment at ${c.salonName}: ${c.date} at ${c.time}. See you!`,
    },
  },
  directions: {
    subject: {
      pl: (c) => `Jak nas znaleźć — ${c.salonName}`,
      uk: (c) => `Як нас знайти — ${c.salonName}`,
      en: (c) => `How to find us — ${c.salonName}`,
    },
    body: {
      pl: (c) => `${c.salonName}${c.address ? ` — adres: ${c.address}.` : "."}${c.code ? ` Kod do drzwi: ${c.code}.` : ""} Do zobaczenia!`,
      uk: (c) => `${c.salonName}${c.address ? ` — адреса: ${c.address}.` : "."}${c.code ? ` Код до дверей: ${c.code}.` : ""} До зустрічі!`,
      en: (c) => `${c.salonName}${c.address ? ` — address: ${c.address}.` : "."}${c.code ? ` Door code: ${c.code}.` : ""} See you!`,
    },
  },
  reminderDirections: {
    subject: {
      pl: (c) => `Przypomnienie i dojazd — ${c.salonName}`,
      uk: (c) => `Нагадування та як знайти — ${c.salonName}`,
      en: (c) => `Reminder & directions — ${c.salonName}`,
    },
    body: {
      pl: (c) => `${hi.pl}${c.name ? " " + c.name : ""}! Przypominamy o wizycie ${c.date} o ${c.time} w ${c.salonName}.${c.address ? ` Adres: ${c.address}.` : ""}${c.code ? ` Kod do drzwi: ${c.code}.` : ""}`,
      uk: (c) => `${hi.uk}${c.name ? ", " + c.name : ""}! Нагадуємо про запис ${c.date} о ${c.time} у ${c.salonName}.${c.address ? ` Адреса: ${c.address}.` : ""}${c.code ? ` Код до дверей: ${c.code}.` : ""}`,
      en: (c) => `${hi.en}${c.name ? " " + c.name : ""}! A reminder about your visit on ${c.date} at ${c.time} at ${c.salonName}.${c.address ? ` Address: ${c.address}.` : ""}${c.code ? ` Door code: ${c.code}.` : ""}`,
    },
  },
  thanks: {
    subject: {
      pl: (c) => `Dziękujemy za wizytę — ${c.salonName}`,
      uk: (c) => `Дякуємо за візит — ${c.salonName}`,
      en: (c) => `Thank you for your visit — ${c.salonName}`,
    },
    body: {
      pl: (c) => `Dziękujemy za wizytę w ${c.salonName}${c.name ? ", " + c.name : ""}!${c.bookUrl ? ` Zapraszamy ponownie: ${c.bookUrl}` : ""}`,
      uk: (c) => `Дякуємо за візит у ${c.salonName}${c.name ? ", " + c.name : ""}!${c.bookUrl ? ` Запрошуємо знову: ${c.bookUrl}` : ""}`,
      en: (c) => `Thank you for visiting ${c.salonName}${c.name ? ", " + c.name : ""}!${c.bookUrl ? ` We look forward to seeing you again: ${c.bookUrl}` : ""}`,
    },
  },
  custom: {
    subject: { pl: (c) => c.salonName, uk: (c) => c.salonName, en: (c) => c.salonName },
    body: { pl: () => "", uk: () => "", en: () => "" },
  },
};

// Побудувати {subject, body} для шаблону+мови з контексту запису/салону.
export function buildMessage(key, lang, ctx = {}) {
  const tpl = T[key] || T.custom;
  const l = MESSAGE_LANGS.includes(lang) ? lang : "pl";
  const c = { salonName: "appointMe", ...ctx };
  return {
    subject: tpl.subject[l](c),
    body: tpl.body[l](c),
  };
}
